module.exports = __webpack_public_path__ + "03_bob_black.632e4eba.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/03_bob_black.png
// module id = ssVf
// module chunks = 0